var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showContent)?_c('div',{staticClass:"admin-main-container"},[_c('side-menu'),_vm._t("default"),_c('demo-greeting')],2):_c('el-skeleton',{staticStyle:{"padding":"16px"},attrs:{"rows":30,"animated":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }